export type GeneralNextAvailabilityStatus =
    | 'onDemand'
    | 'noLongerAvailable'
    | 'unknown';

export const availabilityOrder = [
    'restrictedForOrder',
    'notAvailableForPreorder',
    'available',
    'availableInFuture',
    'notInStock',
    'onDemand',
    'unknown',
    'cannotBeOrderedInDesiredBranch',
    'noLongerAvailable',
    'unavailable',
];

export interface StockQuantity {
    store: string;
    sku: string;
    quantity?: number;
    nextAvailability?: GeneralNextAvailabilityStatus;
    location?: string;
    unavailable?: boolean;
}

export enum StockStatuses {
    UNAVAILABLE = 'unavailable',
    AVAILABLE = 'available',
    AVAILABLE_IN_FUTURE = 'availableInFuture',
    ON_DEMAND = 'onDemand',
    CANNOT_BE_ORDERED_IN_DESIRED_BRANCH = 'cannotBeOrderedInDesiredBranch',
    NO_LONGER_AVAILABLE = 'noLongerAvailable',
    UNKNOWN = 'unknown',
    NOT_IN_STOCK = 'notInStock',
    NOT_AVAILABLE_FOR_PREORDER = 'notAvailableForPreorder',
    RESTRICTED_FOR_ORDER = 'restrictedForOrder',
}

export type StockStatusesWithStaticMessage = Omit<
    StockStatuses,
    StockStatuses.RESTRICTED_FOR_ORDER
>;

export interface FutureStockQuantities {
    store: string;
    sku: string;
    location: string;
    quantities: {
        quantity?: number;
        date: string;
    }[];
}

export type StockMessageValues = Record<
    string,
    string | number | boolean | null | undefined | Date
>;

export interface ProductOrderRestriction {
    store: string;
    sku: string;
    restrictionId?: string;
}
